/**
 * Prepares a single line of RTL caption text for legacy encoders (e.g. Cavena 890)
 * that do not apply full Unicode bidirectional layout.
 *
 * Strips directional embedding marks (U+202B/U+202C), moves trailing sentence
 * punctuation to the leading edge, temporarily relocates a leading speaker marker
 * (>, <, -) to the end of the line, and normalizes spaced ellipsis (" ...").
 *
 * @param {string} text - Plain-text caption line (Hebrew or Arabic).
 * @returns {string} Line reordered for storage/encoding in visual RTL order.
 */
export default (function formatRtlText(text) {
  let punctuation = [",", ".", "!", "?", "¿", ":", ";", '"', "'", "\u201C", "\u201D", "\u2018", "\u2019"];
  let speakerIdentifiers = [">", "<", "-"];
  let i = 0;
  let post = "";
  let replaceA = String.fromCharCode(8235);
  let replaceB = String.fromCharCode(8236);
  let reA = new RegExp(replaceA, "g");
  let reB = new RegExp(replaceB, "g");
  text = text.replace(reA, "").replace(reB, "");
  if (speakerIdentifiers.indexOf(text[0]) > -1) {
    post += text[0];
    text = text.slice(1);
  }
  while (text && punctuation.indexOf(text[text.length - 1]) > -1 && text.length > 1 && i < 10) {
    text = text[text.length - 1] + text.slice(0, -1);
    i++;
  }
  text = text.replace(/(?<=.)\.\.\. /g, " ...") + post;
  return text;
});